import { useEffect, useState } from 'react'

import { useModal } from '@gousto-internal/citrus-react'

// Holds a modal's unconfirmed selection. It re-syncs to the confirmed value each time the modal
// opens, so a choice dismissed without saving doesn't persist.
export const useStagedSelection = <Value>(modalName: string, confirmedValue: Value) => {
  const { getCurrentModal } = useModal()
  const [stagedValue, setStagedValue] = useState(confirmedValue)
  const isOpen = getCurrentModal() === modalName

  useEffect(() => {
    if (isOpen) {
      setStagedValue(confirmedValue)
    }
  }, [isOpen, confirmedValue])

  return [stagedValue, setStagedValue] as const
}
